import { useRef, useState } from 'react';

type Props = {
  disabled?: boolean;
  busy?: boolean;
  onFile: (file: File) => void | Promise<void>;
};

export function PricingUpdatePrfDropzone({ disabled = false, busy = false, onFile }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragOver, setDragOver] = useState(false);
  const locked = disabled || busy;

  const takeFile = (file: File | null | undefined) => {
    if (!file || locked) return;
    void onFile(file);
  };

  const openPicker = () => {
    if (locked) return;
    inputRef.current?.click();
  };

  return (
    <button
      type="button"
      className={`puf-prf-dropzone${dragOver ? ' is-dragover' : ''}${busy ? ' is-busy' : ''}`}
      disabled={locked}
      aria-label="Drag and drop Price Review Form PDF, or click to browse"
      onClick={openPicker}
      onDragEnter={(e) => {
        e.preventDefault();
        if (!locked) setDragOver(true);
      }}
      onDragOver={(e) => {
        e.preventDefault();
        if (!locked) setDragOver(true);
      }}
      onDragLeave={(e) => {
        e.preventDefault();
        setDragOver(false);
      }}
      onDrop={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragOver(false);
        takeFile(e.dataTransfer.files?.[0]);
      }}
    >
      <span className="puf-prf-dropzone__frame">
        <span className="puf-prf-dropzone__label">
          {busy ? 'Reading PDF…' : 'Drag & drop Price Review Form'}
        </span>
      </span>
      <input
        ref={inputRef}
        type="file"
        accept="application/pdf,.pdf"
        hidden
        disabled={locked}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => {
          takeFile(e.target.files?.[0]);
          e.target.value = '';
        }}
      />
    </button>
  );
}
